'use client';

import { copyToClipboard } from '@/utils/voucher-helpers';
import { Check, Copy } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useState } from 'react';

interface VoucherCodeDisplayProps {
    code: string;
}

export default function VoucherCodeDisplay({ code }: VoucherCodeDisplayProps) {
    const t = useTranslations('Common');
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await copyToClipboard(code);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (error) {
            console.error('Failed to copy code:', error);
        }
    };

    return (
        <details className="mt-4">
            <summary className="cursor-pointer text-white/70 hover:text-white uppercase text-sm flex items-center gap-2">
                {t('forRokuAppleTv')}
            </summary>
            <div className="mt-3 p-4 border border-white/50 bg-white/5 flex flex-col gap-3">
                <div className="flex items-center justify-between">
                    <span className="uppercase text-white/70 text-sm">{t('voucherCode')}</span>
                    <button
                        onClick={handleCopy}
                        className="uppercase text-primary text-sm flex items-center gap-2 hover:opacity-80 transition-opacity"
                    >
                        {copied ? (
                            <>
                                <Check className="w-4 h-4" />
                                {t('codeCopied')}
                            </>
                        ) : (
                            <>
                                <Copy className="w-4 h-4" />
                                {t('copyCode')}
                            </>
                        )}
                    </button>
                </div>
                <code className="font-mono text-white text-lg tracking-wider font-bold bg-black/30 p-2">
                    {code}
                </code>
                <p className="text-white/50 text-xs italic">{t('voucherInstructions')}</p>
            </div>
        </details>
    );
}
